var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Help_Button",
    "data-name": "Help Button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 25,
    height: 25,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790",
    transform: "translate(20958.102 3988.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    "data-name": "Path 6023",
    d: "M10.342,0A10.4,10.4,0,1,0,20.8,10.342,10.4,10.4,0,0,0,10.342,0",
    transform: "translate(-20956 -3986)",
    fill: "none",
    stroke: "#5b788f",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 20.798,
    height: 20.798,
    transform: "translate(-20956 -3986)",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4081",
    "data-name": "Group 4081",
    transform: "translate(14452.496 1170.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6051",
    "data-name": "Path 6051",
    d: "M-.734-9.3v-1.5H.453a.348.348,0,0,1,.234.055.274.274,0,0,1,.055.2V-9.3ZM-.7,0V-7.8H.7V0Z",
    transform: "translate(-14440 -1153)",
    fill: "#5b788f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoButton);
export default __webpack_public_path__ + "static/media/icon_info_button.a77beceb93f21abbda310c028c717e69.svg";
export { ForwardRef as ReactComponent };